import type { DynamicFormSettings } from '../@types/form-data-types';

/**
 * Resolves the workflow step a new record should be created at, mirroring how the web app creates a
 * record: it starts at the form's configured initial step, with no choice required from the user.
 *
 * Returns undefined when the form config omits the initial step, so the create payload leaves `status`
 * out and the backend assigns the initial step itself — rather than guessing a step (e.g. the draft or
 * first step), which the backend rejects as an invalid next step for a brand-new record.
 */
export const pickInitialWorkflowStep = (form: DynamicFormSettings): string | undefined => form.initialStep?.label;
